import { render, staticRenderFns } from "./google-tag-display.vue?vue&type=template&id=1721d258"
import script from "./google-tag-display.vue?vue&type=script&lang=js"
export * from "./google-tag-display.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports